import { render, staticRenderFns } from "./screeningsConfiguration.vue?vue&type=template&id=78e04cd7&scoped=true&"
import script from "./screeningsConfiguration.vue?vue&type=script&lang=js&"
export * from "./screeningsConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e04cd7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AeqAlertsSettings: require('/home/vsts/work/1/s/components/AeqAlertsSettings.vue').default})
